import { OCP_APIM_SUBSCRIPTION_KEY } from '../../../constants/apiConfig';
import { frontendConfig } from '../../global/utils/commonUtils';

export const CCA_ENTRY_SCREEN = window?.location?.protocol + '//' + window?.location?.host + '/createaccount/customer';

export const API_CONFIG = {
    BASE_URL: 'https://qa-api.sunbeltrentals.com/',
    GET_CCA_CONFIG: 'web/api/v1/aem/ccaConfigurations',
    GET_AUTH_TOKEN: 'api/v1/oauth2/token',
    GET_CCA_APPLICATION: 'web/api/v1/cca/application',
    SUBMIT_APPLICATION: 'web/api/v1/cca/submission',
    FINALIZE_APPLICATION: 'web/api/v1/cca/application/signature'
};

export const getClientId = () => {
    return frontendConfig?.openidmuleclientid || '0oa3cjs4xbyricVYP1d7';
};

export const getClientSecret = () => {
    return frontendConfig?.openidmuleclientsecret || 'lkSpZKIfO-y4vPZSYyDlnDagwSOvWlTR6e8U4hbi';
};

export const getOpenIdOcpApimSubscriptionKey = () => {
    return frontendConfig?.openidocpapimsubscriptionkey || '';
};

export const getApiConfigByEnv = () => {
    const muleDomain = frontendConfig?.muledomain || API_CONFIG.BASE_URL;
    return {
        baseURL: muleDomain, // api domain
        timeout: 60000,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            client_id: getClientId(),
            client_secret: getClientSecret(),
            [OCP_APIM_SUBSCRIPTION_KEY]: getOpenIdOcpApimSubscriptionKey()
        }
    };
};
